import { render, staticRenderFns } from "./rippon-vineyards.vue?vue&type=template&id=4d07e6e2&scoped=true"
import script from "./rippon-vineyards.vue?vue&type=script&lang=js"
export * from "./rippon-vineyards.vue?vue&type=script&lang=js"
import style0 from "./rippon-vineyards.vue?vue&type=style&index=0&id=4d07e6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d07e6e2",
  null
  
)

export default component.exports